import type { FlowId } from '@grafx-vdp/shared';

import { apiFetch } from './client.js';

export interface TriggerFlowResponse {
  accepted: boolean;
  message: {
    type: 'flow.run.enqueued';
    tenantId: string;
    flowId: FlowId;
    triggerSource: 'manual';
    scheduledAt: string;
    payload?: Record<string, unknown>;
  };
}

export function triggerFlow(
  jwt: string | null,
  flowId: FlowId,
  payload?: Record<string, unknown>,
): Promise<TriggerFlowResponse> {
  return apiFetch<TriggerFlowResponse>('/api/trigger', {
    jwt,
    method: 'POST',
    json: { flowId, payload },
  });
}
